"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "recommend_mail": { "id": null, "hf_member_id": null, "recommend_mail_type": null, "is_including_meeting_schedule": null, "active_remind_mail_recruitments": [{ "id": null, "reason_en": null, "reason_ja": null, "recruitment_id": null }] } });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "recommend_mail": { "id": null, "hf_member_id": null, "recommend_mail_type": null, "is_including_meeting_schedule": null, "active_remind_mail_recruitments": [] } });
    }
    build(key) { return { "active_remind_mail_recruitments": { "id": null, "reason_en": null, "reason_ja": null, "recruitment_id": null } }[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.patch("/jtj/commands/hf_member__set_recommend_mail", { params });
    }
};
